/**
 * @fileName      csdStaffService
 * @dateTime      2021/4/1 14:28:40
 * @author        Millionfor <millionfor@gmail.com>
 * @description   客服人员管理器
 */

import io, { serverAlias } from '@/module/io'
import MC from '@/module/MC'

class CsdStaff {
  /**
   * 客服分组占比统计
   *
   * @param {String} xxx
   */
  queryStaffGroupStatistics (payload) {
    return new Promise((resolve, reject) => {
      const { merCode } = MC.config.userInfo
      io.post(`${serverAlias.merManager}/1.0/csd-staff/group-statistics`, { ...payload, merCode }, res => {
        resolve(res.data)
      }, e => {
        reject(e)
      }, { emulateJSON: false })
    })
  }
  /**
   * 客服工作量统计
   *
   * @param {String} xxx
   */
  queryStaffWorkloadStatistics (payload) {
    return new Promise((resolve, reject) => {
      const { merCode, id } = MC.config.userInfo
      io.post(`${serverAlias.merManager}/1.0/csd-staff/workload-statistics`, { ...payload, merCode, staffId: id }, res => {
        resolve(res.data)
      }, e => {
        reject(e)
      }, { emulateJSON: false })
    })
  }
  /**
   * 客服工作质量统计
   *
   * @param {String} xxx
   */
  queryStaffWorkQuality (payload) {
    return new Promise((resolve, reject) => {
      const { merCode, id } = MC.config.userInfo
      io.post(`${serverAlias.merManager}/1.0/csd-staff/work-quality`, { ...payload, merCode, staffId: id }, res => {
        resolve(res.data)
      }, e => {
        reject(e)
      }, { emulateJSON: false })
    })
  }
  /**
   * 查看单个客服
   *
   * @param {String} xxx
   */
  querySingleStaff () {
    return new Promise((resolve, reject) => {
      const { merCode, id } = MC.config.userInfo
      io.get(`${serverAlias.merManager}/1.0/csd-staff/single-staff?merCode=${merCode}&userId=${id}`, res => {
        resolve(res.data)
      }, e => {
        reject(e)
      }, { emulateJSON: false })
    })
  }

  /**
   * 客服数据统计
   *
   * @param {String} merCode 商户编码
   * @param {staffId} merCode 客服ID
   * @param {statisticsMonth} merCode 统计月份
   * @returns {promise}
   */
  queryStaffStatistics (payload) {
    return new Promise((resolve, reject) => {
      const { merCode } = MC.config.userInfo
      io.post(`${serverAlias.merManager}/1.0/csd-staff/staff-statistics`, { ...payload, merCode }, res => {
        resolve(res.data)
      }, e => {
        reject(e)
      }, { emulateJSON: false })
    })
  }
  /**
   * 查看客服详情
   *
   * @param {String} merCode 商户编码
   * @param {String} staffId 客服id
   * @returns {promise}
   */
  getStaffDetails (payload) {
    return new Promise((resolve, reject) => {
      const { merCode } = MC.config.userInfo
      io.post(`${serverAlias.merManager}/1.0/csd-staff/staff-detail`, { ...payload, merCode }, res => {
        resolve(res.data)
      }, e => {
        reject(e)
      }, { emulateJSON: false })
    })
  }

  /**
   * 更新客服信息
   *
   * @param {String} all 查询条件 (员工编码+手机号+员工姓名)
   * @param {String} avatarPath 员工头像
   * @param {Number} currentPage 当前页
   * @param {Number} isDelete 软删除，0-已删除，1-正常
   * @param {Number} isPage 是否分页 0-不分页 1-分页
   * @param {String} merCode 商户编码
   * @param {String} mobile 客服手机号
   * @param {Number} onlineStatus 在线状态，0-不在线，1-在线
   * @param {Number} pageSize 每页显示条数，不传默认20
   * @param {String} staffId 客服ID
   * @param {Array<Number>} staffIds 多个客服ID
   * @param {String} storeCode 门店编码
   * @param {Number} type 客服类型,1-商户客服，2-门店客服
   * @returns {promise}
   */
  updateStaffCs (payload) {
    return new Promise((resolve, reject) => {
      const { merCode } = MC.config.userInfo
      io.post(`${serverAlias.merManager}/1.0/csd-staff/_modifyStaff`, { ...payload, merCode }, res => {
        resolve(res.data)
      }, e => {
        reject(e)
      }, { emulateJSON: false })
    })
  }

  /**
   * 删除客服
   *
   * @param {String} merCode 商户编码
   * @param {String} staffId 员工id
   * @returns {promise}
   */
  deleteStaffCs (payload) {
    const { staffId } = payload
    return new Promise((resolve, reject) => {
      const { merCode } = MC.config.userInfo
      io.delete(`${serverAlias.merManager}/1.0/csd-staff/${merCode}/${staffId}`, res => {
        resolve(res.data)
      }, e => {
        reject(e)
      })
    })
  }
  /**
   * 添加客服
   *
   * @param {Number} currentPage 当前页
   * @param {Number} isDelete 软删除，0-已删除，1-正常
   * @param {Number} isPage 是否分页 0-不分页 1-分页
   * @param {String} merCode 商户编码
   * @param {String} mobile 客服手机号
   * @param {Number} onlineStatus 在线状态，0-不在线，1-在线
   * @param {Number} pageSize 每页显示条数，不传默认20
   * @param {String} staffId 客服ID
   * @param {Array<Number>} staffIds 多个客服ID
   * @param {String} storeCode 门店编码
   * @param {Number} type 客服类型,1-商户客服，2-门店客服
   * @returns {promise}
   */
  createStaffCs (payload) {
    return new Promise((resolve, reject) => {
      const { merCode } = MC.config.userInfo
      io.post(`${serverAlias.merManager}/1.0/csd-staff/_addStaff`, { ...payload, merCode }, res => {
        resolve(res.data)
      }, e => {
        reject(e)
      }, { emulateJSON: false })
    })
  }

  /**
   * 多条件查询
   *
   * @param {Number} accountType 账户类型：0-员工账户；1-门店账户
   * @param {Number} currentPage 当前页，从第1页开始，不传默认为1
   * @param {String} empName 员工名称
   * @param {Boolean} hasCorpWeChat 是否接入企业微信
   * @param {Number} isPayAddEmployee 是否支付即服务中添加员工查询 1：是 0 否
   * @param {Number} isPaySerice 是否支付既服务查询 1:是 0 否
   * @param {String} merCode 商家编码
   * @param {Boolean} pageFlag 是否要分页true分页，false不分页,默认为true
   * @param {Number} pageSize 每页显示条数，不传默认20
   * @param {Number} payServiceStatus 0:初始 1:绑定 2：解绑
   * @param {Array<String>} roleIds
   * @param {String} searchKey 员工搜索键：员工姓名模糊搜索，员工编码精确搜索，手机号码精确搜索
   * @param {Number} status 状态（0：禁用，1：启用）
   * @param {String} subOrgCode 机构编码
   * @param {String} subOrgName 部门名称
   * @param {String} userId 员工编码
   * @returns {promise}
   */
  queryAllCsData (payload) {
    return new Promise((resolve, reject) => {
      const { merCode } = MC.config.userInfo
      io.post(`${serverAlias.merManager}/1.0/csd-staff/_searchEmployee`, { ...payload, merCode }, res => {
        resolve(res.data)
      }, e => {
        reject(e)
      }, { emulateJSON: false })
    })
  }

  /**
   * 查询客服列表
   *
   * @param {Number} currentPage 当前页
   * @param {Number} isDelete 软删除，0-已删除，1-正常
   * @param {Number} isPage 是否分页 0-不分页 1-分页
   * @param {String} merCode 商户编码
   * @param {String} mobile 客服手机号
   * @param {Number} onlineStatus 在线状态，0-不在线，1-在线
   * @param {Number} pageSize 每页显示条数，不传默认20
   * @param {String} staffId 客服ID
   * @param {Array<Number>} staffIds 多个客服ID
   * @param {String} storeCode 门店编码
   * @param {Number} type 客服类型,1-商户客服，2-门店客服
   * @returns {promise}
   */
  queryCsData (payload) {
    return new Promise((resolve, reject) => {
      const { merCode } = MC.config.userInfo
      io.post(`${serverAlias.merManager}/1.0/csd-staff/staff-list`, { ...payload, merCode }, res => {
        resolve(res.data)
      }, e => {
        reject(e)
      }, { emulateJSON: false })
    })
  }

  /**
   * 查看客服详情
   *
   * @param {String} merCode 商户编码
   * @param {String} staffId 客服ID
   * @returns {promise}
   */
  queryCsDetails (payload) {
    return new Promise((resolve, reject) => {
      const { merCode } = MC.config.userInfo
      io.get(`${serverAlias.merManager}/1.0/csd-staff/staff-detail`, { ...payload, merCode }, res => {
        resolve(res.data)
      }, e => {
        reject(e)
      }, { emulateJSON: false })
    })
  }
}

export default new CsdStaff()



// WEBPACK FOOTER //
// ./src/js/module/apis/csdStaffService.js